var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.discount, ( _obj = {}, _obj[_vm.$style.small] = _vm.small, _obj )]},[_c('b',[_vm._v(" -"+_vm._s(_vm.discount)+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }